import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useMutation } from 'react-apollo'
import { withAuthProvider } from '../../lib/auth'
import { LoadingComponent } from '@pga/pga-component-library'
import PaymentPanel from '../PaymentContainer/PaymentPanel'
import ProxyRequestForm from './ProxyRequestForm'
import ProxyInstructions from './ProxyInstructions'
import { CREATE_PROXY } from '../../queries/proxy'

const ProxyRequest = ({ me, authReady, history }) => {
  const [formData, setFormData] = useState({
    memberEmail: '',
    proxyFirstName: '',
    proxyLastName: '',
    proxyEmail: '',
    confirmProxyEmail: ''
  })

  useEffect(() => {
    if (!authReady) { return }
    setFormData(formData => ({ ...formData, memberEmail: me.primaryEmail }))
  }, [me, authReady])

  const [createProxy, { loading }] = useMutation(CREATE_PROXY, {
    onCompleted: () => history.replace('/success?type=proxy-request'),
    onError: () => history.push('/no-invoices')
  })

  const handleChange = (id) => ({ target: { value } }) => {
    setFormData({ ...formData, [id]: value })
  }

  const handleSubmit = async () => {
    createProxy({
      variables: {
        input: {
          proxyFirstName: formData.proxyFirstName,
          proxyLastName: formData.proxyLastName,
          proxyEmail: formData.proxyEmail
        }
      }
    })
  }

  if (loading) return <LoadingComponent />

  return (
    <PaymentPanel>
      <ProxyInstructions me={me} />
      <ProxyRequestForm
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </PaymentPanel>
  )
}

export default withRouter(withAuthProvider(ProxyRequest))
